import { Flex } from "antd";
import React from "react";

import PatientsWithHighestBalance from "./PatientsWithHighestBalance";
import RevenuePerTreatmentType from "./RevenuePerTreatmentType";
import FinancialStatistics from "./FinancialStatistics";
import MonthlyRevenue from "./MonthlyRevenue";
import FinancialScore from "./FinancialScore";
import PaymentMethod from "./PaymentMethod";
import DefaultRate from "./DefaultRate";
import ARAging from "./ARAging";
import Payments from "./payments/Payments";

export default function FinancialAnalytics() {
  return (
    <Flex vertical gap={30}>
      <Flex gap={30}>
        <PaymentMethod />
        <RevenuePerTreatmentType />
        <FinancialStatistics />
      </Flex>

      <MonthlyRevenue />

      <Flex gap={30}>
        <DefaultRate />
        <FinancialScore />
      </Flex>

      <Flex gap={30}>
        <PatientsWithHighestBalance />
        <ARAging />
      </Flex>

      <Payments />
    </Flex>
  );
}
